<template>
  <div class="sf-pad-b-2 sf-pad-r-2 sf-level">
    <div class="sf-level sf-level-between">
      <div class="audit-message sidebar-audit-log-item">
        <span
          v-dompurify-html="message"
          :class="{ 'sf-hidden': showMore }"
          data-testid="audit-log-item__message"
        ></span>
        <a
          v-if="isAdjustmentUpdate"
          class="sf-btn sf-btn-small"
          data-testid="audit-log-item__adjustment-details"
          @click="($event) => openAdjustmentDiffModal($event)"
          >{{ I18n.t('account_entry.assistant.check.details') }}</a
        >
        <template v-if="trimmed">
          <a
            class="sf-font-xs sf-bold"
            :class="{ 'sf-hidden': showMore }"
            data-testid="audit-log-item__show-more"
            @click="showMore = true"
          >
            {{ I18n.t('audit.show_more') }}
          </a>
          <!-- TODO: we interpolate and purify fullAuditMessage here as it's a HTML string coming from the audits_helper
            that contains user input, and thus may potentially contain malicious javascript -->
          <span
            v-dompurify-html="fullAuditMessage"
            :class="{ 'sf-hidden': !showMore }"
            data-testid="audit-log-item__full-audit-message"
          ></span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  props: {
    trimmed: {
      type: Boolean,
    },
    message: {
      type: String,
      required: true,
    },
    fullAuditMessage: {
      type: String,
      default: undefined,
    },
    action: {
      type: String,
      required: true,
    },
    auditableType: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    hasDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMore: false,
    }
  },
  computed: {
    isAdjustmentUpdate() {
      return (
        this.hasDetails &&
        this.action === 'update' &&
        this.auditableType === 'Adjustment'
      )
    },
    adjustmentDiffRoute() {
      return Silverfin.Routes.adjustment_diff_ledger_audit_path(
        Silverfin.currentFirmId,
        Silverfin.currentCompanyId,
        Silverfin.currentLedgerId(),
        this.id
      )
    },
  },
  mounted() {
    this.initTooltips()
  },
  updated() {
    this.initTooltips()
  },
  methods: {
    initTooltips() {
      this.$nextTick(() => {
        $(this.$el)
          .find('[data-toggle="tooltip"]')
          .each((_idx, element) => {
            $(element).trigger('tooltipsRendered', element.parentElement)
          })
      })
    },
    openAdjustmentDiffModal(e) {
      window.modalCitizen.openXhrModal(
        e,
        'adjustment-diff',
        this.adjustmentDiffRoute,
        {}
      )
    },
  },
}
</script>
<style>
.sidebar-audit-log-item .adjustment-changes {
  display: none;
}
</style>
